import React from 'react';
import ChatMessages from './ChatMessages';

const ChatContainer = ({ 
  messages, 
  isTyping, 
  onSendMessage, 
  sendButtonDisabled,
  inputDisabled,
  inputPlaceholder,
  userTag
}) => {
  return (
    <div className="chat-container">
      <ChatMessages 
        messages={messages} 
        isTyping={isTyping}
        onSendMessage={onSendMessage}
        inputDisabled={inputDisabled}
        inputPlaceholder={inputPlaceholder}
        userTag={userTag}
      />
    </div>
  );
};

export default ChatContainer;
